import "./navbarstocks.css"
import React from 'react'
import StocksContext from '../../../contexts/StocksContext'
import { StocksTemplateRow } from '../stocks/StocksTemplateRow'
import {Nav} from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ArrowBack } from "@mui/icons-material"
import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from '../../../contexts/AuthContext'
import { SaveChat } from '../savechat/SaveChat'
import {PushButton} from '../pushbutton/PushButton'
import CircularProgress from '@mui/material/CircularProgress';
import {LoginDialog} from '../logindialog/LoginDialog'

export const NavBarStocks = ({ title })=> {
  const [expanded, setExpanded] = useState(false);
 

  let {
    deleteTemplate,
    displayTemplate,
    templates,
    templateName,
    setTemplateName,
    prompts,
    onSave,
    getTemplates,
    displayExample1,
    displayExample2,
    displayExample3,
   
} = React.useContext(StocksContext);

let {
  isLoading,
  statusNavbar,
  setStatusNavbar,
  changeLanguage,
  changeLanguageEnglish,
  setShowLoginDialog,
} = React.useContext(StatusContext);

const {
  checkCurrentUser,
} = React.useContext(AuthContext);


const onBuyExample1 = () => {
  displayExample1()
  setExpanded(!expanded)
}

const onBuyExample2 = () => {
  displayExample2()
  setExpanded(!expanded)
}
const onBuyExample3 = () => {
  displayExample3()
  setExpanded(!expanded)
}

const handleonArrowClick = () => {
  console.log("HandleOnArrowClick")
  setExpanded(!expanded)
 
}
const handleonClickNavBar = async () => {

  setStatusNavbar("");
  if (checkCurrentUser() === false)
    {
        setShowLoginDialog(true)
        return;
    }
  getTemplates()
  setExpanded(!expanded)
 
}

const handleSelect = () => {
  setExpanded(!expanded)
}

const onTemplateNameChange = (e) => {

  setTemplateName(e.target.value)
  if (e.target.value.length)
    setStatusNavbar("");
}

  return (
    <Navbar expanded={expanded} key={false} bg="" expand={false} className="mb-2 py-0" sticky=''>
    
      {
          isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'white' }}/>
            </div>
        }

      <div>
       <label className="navbarTitle"> {title}</label>
       <label className="navbarTemplateName"> {templateName} </label>
      </div>
      <div style = {{marginRight: '10px'}}>
        <PushButton onClick={handleonClickNavBar} label =  {changeLanguage('stocks','archive')}/>
      </div>
   
    
        
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
          
        >
          <Offcanvas.Header onClick={handleSelect}>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
            <ArrowBack className="styleIconWithBackground" onClick = {handleonArrowClick} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              
            <label className="navbarTemplatesTitle">{changeLanguage('stocks', 'strategies')}</label>

            <div className="navbarContainer" >
           
              <ul className="navbarNames">
                  {
                      Array.isArray(templates) &&
                          templates.map((chat) => (
                              <StocksTemplateRow key = {chat.id} chat={chat} deleteHandler={deleteTemplate} clickHandler={displayTemplate} setExpand = {handleSelect} setTemplateName = {setTemplateName} />
                          ))
                  }
              </ul>
            </div>

            <br></br>
              <SaveChat label={changeLanguageEnglish('stocks', 'topicname')} text={templateName} disabled={prompts===null || prompts.length === 0} onChange={onTemplateNameChange} onSave={onSave}/>
           

            {
              (statusNavbar) &&
                      <div style={{ color: "red" }}><label>{statusNavbar}</label></div> 
            } 
            <br></br>

            <div className='navbarFonts'>
                
             <label style={{fontWeight:'500'}}>Examples of strategies:</label>
              <br></br>
           

                <div>
                   {changeLanguageEnglish('stocks', 'navbartext2')}    
                    <br></br>
                    <br></br>

                    <label style={{fontWeight:'500'}}>Example 1:</label>
                    <br></br>
                    <label> {changeLanguageEnglish('stocks', 'navbarexample1_1')}  </label>
                    <br></br>
                    <button
                      type="button"
                      onClick={onBuyExample1}
                      className="add-btn"
                    >
                      <label style={{fontSize:'18px'}}>Buy - dip 5% 10days</label>
                    </button>
                    <br></br>
                    <br></br>

                 
                 

                    <label style={{fontWeight:'500'}}>Example 2:</label>
                    <br></br>
                    <label> {changeLanguageEnglish('stocks', 'navbarexample2_1')}  </label>
                    <br></br>

                    <button
                      type="button"
                      onClick={onBuyExample2}
                      className="add-btn"
                    >
                      <label style={{fontSize:'18px'}}>Buy - up 5% 10days</label>
                    </button>
                    <br></br>
                    <br></br>

                    <label style={{fontWeight:'500'}}>Example 3:</label>
                    <br></br>
                    <label> {changeLanguageEnglish('stocks', 'navbarexample3_1')}  </label>
                    <br></br>

                    <button
                      type="button"
                      onClick={onBuyExample3}
                      className="add-btn"
                    >
                      <label style={{fontSize:'18px'}}>Analyze stocks</label>
                    </button>
                    <br></br>
                    <br></br>
              </div>
      
             {changeLanguageEnglish('stocks', 'navbartext6')}    
              <br></br>
              <br></br>
                
              {changeLanguageEnglish('stocks', 'navbartext3')}    
              <br></br>
              <br></br>

              {changeLanguageEnglish('stocks', 'navbartext4')}    
              <br></br>
              <br></br>

              {changeLanguageEnglish('stocks', 'navbartext5')}    
              <br></br>
              <br></br>
              
            </div>

            </Nav>
           
             <LoginDialog />
          </Offcanvas.Body>
        </Navbar.Offcanvas>
    
    </Navbar>
  );
}

export default NavBarStocks;